export const XTOKEN = 'xToken';
